<template>
  <div>
    <div
      class="flex items-center gap-1 dropdown-holder-title"
      v-if="validationErrorPosition || validationErrorPosition === 'top'"
    >
      <p class="text-title">{{ Object.keys(option)[0] | capitalize }}</p>
      <div v-if="showValidationError" class="validation-error">
        <small>Required</small>
      </div>
    </div>
    <v-select
      class="custom gift-select product"
      :class="{
        'invalid-input': checkValidity(product.id, Object.keys(option)[0])
      }"
      :options="Object.values(option)[0]"
      :placeholder="`Select ${Object.keys(option)[0]}`"
      :clearable="false"
      :searchable="false"
      v-model="selectedItem"
      :value="setValue(product.id, Object.keys(option)[0])"
      @input="
        value => {
          updateSelection(value, option)
          showValidationError = false
        }
      "
      @open="$emit('isSelectOpen', true)"
      @close="$emit('isSelectOpen', false)"
    >
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes"> <Dropdown /> </span>
      </template>
    </v-select>
    <div
      class="validation-error"
      v-if="
        checkValidity(product.id, Object.keys(option)[0]) &&
          (!validationErrorPosition || validationErrorPosition === 'bottom')
      "
    >
      <small>Required</small>
    </div>
  </div>
</template>
<script>
import Dropdown from '@/components/Universal/Dropdown.vue'
export default {
  components: { Dropdown },
  props: ['option', 'product', 'selectedItems', 'validationErrorPosition'],
  data() {
    return {
      selectedItem: '',
      showValidationError: false
    }
  },
  computed: {
    isSelectedValid() {
      return this.selectedItem
    }
  },

  created() {
    if (this.selectedItems.length > 0) {
      const value = this.setValue(this.product.id, Object.keys(this.option)[0])

      if (value) {
        this.selectedItem = value
      }
    }
  },

  methods: {
    checkValidity(id, option) {
      return !this.setValue(id, option) && this.showValidationError
    },
    setValue(id, option) {
      const product = this.selectedItems.find(item => item.id == id)

      if (product) {
        if (product.option !== undefined) {
          const value = product.option[option]
          return value || ''
        } else {
          const value = product.admin_order_product_option_sets[option]
          return value || ''
        }
      }
    },
    updateSelection(value, option) {
      this.$parent.selectedItem = this.selectedItem
      this.$parent.updateSelection(value, option)
    }
  }
}
</script>

<style lang="scss">
.dropdown-holder-title {
  margin-bottom: 0.25rem;

  .text-title {
    font-size: 0.938rem;
    color: #232220;
    font-weight: bold;
  }
}
</style>
